/**
 * 대한민국 공휴일 — 백엔드(DB)에서 조회. 동기화는 서버에서
 * `python manage.py sync_korean_holidays` (공공데이터 API 키는 백엔드 환경 변수).
 */
import useAxios from "./useAxios";

/**
 * @param {number} year
 * @param {number} month1to12 1–12
 * @returns {Promise<Record<string, string>>} locdate YYYYMMDD → 공휴일명
 */
export async function fetchKoreanHolidays(year, month1to12) {
	const { data } = await useAxios.get("utils/holidays/", {
		params: {
			year,
			month: month1to12,
		},
	});
	const holidays = data?.holidays;
	if (!holidays || typeof holidays !== "object") {
		return {};
	}
	return holidays;
}
